// Re-export from @capone/common to maintain backward compatibility
export type { LifestyleEligibilityResponse } from "@capone/common";

// Helper function for non-RTK Query usage (sagas, etc)
import axios from "axios";
import { LifestyleEligibilityResponse } from "@capone/common";

export const checkLifestyleEligibility = (): Promise<LifestyleEligibilityResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post("/api/v0/users/lifestyleEligibility", {});
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
